import type { Locale } from "./en";

// Polish translations. Missing keys fall back to English via i18next.
export const pl: Locale = {
  common: {
    home: "Start",
    no_scores: "Brak punktów",
    points_count_one: "{{count}} punkt",
    points_count_other: "{{count}} punktów",
    questions_count_one: "{{count}} pytanie",
    questions_count_other: "{{count}} pytań",
  },
  home: {
    placeholder: "Kod gry",
    enter: "Dołącz",
    error_invalid_code:
      "Wpisz 6-znakowy kod gry od nauczyciela.",
    footer: "Rozpocznij Binogi Buzz z produktów Binogi.com.",
    language_label: "Język",
  },
  errors: {
    generic: "Coś poszło nie tak. Spróbuj ponownie.",
    stale_client: "Twoja strona jest nieaktualna — odśwież ją.",
    session_not_found: "Nie znaleziono tej sesji.",
    session_not_open: "Ta sesja się zakończyła.",
    session_not_active: "To pytanie lub sesja już się zakończyły.",
    not_teacher: "Tylko nauczyciel może to zrobić.",
    already_answered: "Już odpowiedziałeś na to pytanie.",
    wrong_question_index: "To pytanie jeszcze się nie zaczęło.",
    name_taken: "Ta nazwa jest już zajęta. Wybierz inną.",
    character_busy: "Nie udało się teraz przydzielić ci postaci — spróbuj ponownie.",
  },
  host: {
    input: {
      heading: "Rozpocznij Buzz",
      lead:
        "Wpisz kod lekcji Binogi, nad którą pracują uczniowie. Wczytamy pytania i utworzymy sesję, którą możesz wyświetlić na tablicy.",
      lesson_code_label: "Kod lekcji",
      placeholder_code: "BIH750",
      load_button: "Wczytaj lekcję",
      try_hint: "Spróbuj:",
      error_invalid_code: "Wpisz kod lekcji Binogi, np. BIH750.",
      error_not_found: "Nie znaleziono lekcji o kodzie {{code}}.",
      error_unreachable: "Nie udało się połączyć z serwerem lekcji. Sprawdź połączenie i spróbuj ponownie.",
      error_no_questions: "Lekcja {{code}} nie ma pytań, których Buzz może użyć.",
      error_no_level_questions: "Lekcja {{code}} nie ma pytań na wybranym poziomie.",
    },
    loading: "Wczytywanie lekcji…",
    placeholder_title: "Rozpocznij Binogi Buzz",
    tab_details: "Szczegóły",
    tab_questions: "Pytania",
    settings: "Ustawienia",
    number_of_students: "Liczba uczniów",
    fewer_students: "Mniej uczniów",
    more_students: "Więcej uczniów",
    player_names: "Imiona graczy",
    player_anonymous: "Anonimowo",
    player_self_chosen: "Uczniowie wybierają",
    language: "Język",
    language_teacher: "Nauczyciel wybiera",
    language_students: "Uczniowie wybierają",
    time_per_question: "Czas na pytanie",
    time_option: "{{seconds}} s",
    start_button: "Rozpocznij sesję",
    start_disabled: "Ustaw liczbę uczniów, aby zacząć",
    creating: "Tworzenie sesji…",
    error_no_questions: "Zostaw przynajmniej jedno pytanie przed startem.",
    error_create_failed: "Nie udało się utworzyć sesji",
    error_load_failed: "Nie udało się wczytać lekcji",
    no_session: "Żadna sesja nie trwa.",
    back_to_review: "Wróć do pytań",
    errors: {
      dismiss: "Zamknij",
      refresh: "Odśwież",
      attach_failed: "Ten ekran nie mógł połączyć się jako nauczyciel.",
      unreachable: "Nie udało się połączyć z serwerem. Odśwież stronę, aby spróbować ponownie.",
      no_token: "Ta karta nie może już sterować quizem. Otwórz Buzz ze swojej lekcji, aby rozpocząć nową sesję.",
      taken_over: "Ten quiz jest teraz prowadzony z innego ekranu.",
      stale_question: "Buzz został zaktualizowany w trakcie quizu, więc ten ekran nie może go kontynuować. Przeładuj stronę, aby wrócić do quizu w miejscu, w którym jest klasa.",
      question_moved_on: "Quiz już poszedł dalej, więc ten ekran jest w tyle. Przeładuj stronę, aby wrócić do quizu w miejscu, w którym jest klasa.",
    },
    entry: {
      opening: "Otwieranie widoku nauczyciela…",
      token_title: "Nie można otworzyć tego linku nauczyciela",
      token_body: "W linku brakuje klucza nauczyciela albo link wygasł. Otwórz Buzz ze swojej lekcji, aby utworzyć nową sesję.",
      not_found_title: "Nie znaleziono sesji",
      not_found_body: "Ta sesja quizu już nie istnieje. Utwórz nową, aby kontynuować.",
      back: "Wróć na start",
    },
    questions: {
      drag_aria: "Przeciągnij, aby zmienić kolejność",
      remove_aria: "Usuń pytanie",
      empty: "W tej sesji nie ma już pytań.",
      add: "Dodaj",
      add_aria: "Dodaj pytanie: {{text}}",
      add_all: "Dodaj wszystkie",
      add_all_n: "Dodaj wszystkie {{count}} pytań",
      more_one: "{{count}} pytanie więcej w tej lekcji",
      more_few: "{{count}} pytania więcej w tej lekcji",
      more_many: "{{count}} pytań więcej w tej lekcji",
      more_other: "{{count}} pytań więcej w tej lekcji",
      level_easy: "Łatwy",
      level_medium: "Średni",
      level_hard: "Trudny",
      multi: "Wielokrotny",
    },
    lobby: {
      go_to: "Wejdź na <strong>buzz.binogi.com</strong> i wpisz:",
      or_qr: "…lub zeskanuj kod QR",
      students_joined_of: "Dołączyło {{joined}} z {{expected}} uczniów",
      students_joined_one: "Dołączył {{count}} uczeń",
      students_joined_other: "Dołączyło {{count}} uczniów",
      waiting: "Czekamy, aż uczniowie dołączą…",
      start_game: "Rozpocznij grę",
      connected: "Połączono",
      connecting: "Łączenie…",
      copy_link: "Kopiuj link",
      copy_link_copied: "Skopiowano!",
    },
    question: {
      header: "Pytanie {{index}} z {{total}}",
      level: "Poziom {{level}}",
      none: "Brak aktywnego pytania.",
      answered: "Odpowiedziało",
      top_n: "Top {{count}}",
      answers_heading: "Odpowiedzi",
      end_question: "Zakończ pytanie",
      next_question: "Następne pytanie",
      see_results: "Zobacz wyniki końcowe",
    },
    results: {
      heading: "Wyniki końcowe",
      all_players: "Wszyscy gracze",
      end_session: "Zakończ sesję",
      new_session: "Nowa sesja",
      none: "Brak graczy w tej sesji.",
    },
  },
  join: {
    code_label: "Kod gry",
    name_label: "Twoje imię",
    name_placeholder: "Wpisz swoje imię",
    join_button: "Dołącz",
    joining: "Dołączanie…",
    checking: "Sprawdzanie…",
    character_hint:
      "Po dołączeniu dostaniesz zabawne imię postaci z Binogi.",
    error_not_found:
      "Ten kod nie jest jeszcze aktywną sesją. Zapytaj nauczyciela.",
    error_lookup_failed: "Nie udało się znaleźć sesji",
    error_code_required: "Wpisz 6-znakowy kod.",
    error_name_required: "Wpisz swoje imię.",
  },
  play: {
    superseded: "Masz połączenie w innej karcie — zamknij ją, aby grać dalej tutaj.",
    back_to_join: "Wróć do dołączania",
    no_round: "Brak danych rundy.",
    not_joined: "Nie dołączyłeś do żadnej sesji.",
    no_question: "Brak aktywnego pytania.",
    keep_awake_hint: "Dotknij ekranu, aby nie wygasł",
    waiting: {
      you_are: "Jesteś",
      get_ready_named: "Przygotuj się, {{name}}!",
      get_ready: "Przygotuj się do quizu!",
      in_room_label: "Uczniowie w pokoju",
      in_room_one: "{{count}} uczeń w pokoju",
      in_room_other: "{{count}} uczniów w pokoju",
    },
    question: {
      progress: "{{index}} / {{total}}",
      answered: "Odpowiedziano!",
      times_up: "Koniec czasu",
      submit: "Wyślij",
      submit_n: "Wyślij {{count}} odpowiedzi",
    },
    between: {
      correct: "Dobrze!",
      wrong: "Prawie!",
      times_up: "Koniec czasu",
      points_gained: "+{{count}} punktów",
      your_score: "Twój wynik",
      your_rank: "Miejsce {{rank}}",
      top_n: "Top {{count}}",
      waiting_next: "Czekamy na następne pytanie…",
    },
    finished: {
      heading: "Dzięki za grę w Binogi Buzz!",
      your_final_rank: "Twoje końcowe miejsce",
      top_n: "Top {{count}}",
      none: "Brak wyników do pokazania.",
    },
  },
  characters: {
    heading: "Postacie Binogi",
    lead:
      "{{count}} uczniów dostaje postać po dołączeniu, w tej kolejności.",
  },
};
